<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
========================================================================================== -->


<template>
  <div class="layout--main" :class="[navbarClasses, footerClasses, {'app-page': isAppPage}]">
    <vx-tour :steps="steps" name="beginnerTour" ref="vxBeginnerTour" v-if="!disableThemeTour" />

    <the-customizer
      @updateNavbar="updateNavbar"
      @updateNavbarColor="updateNavbarColor"
      :navbarType="navbarType"
      :navbarColor="navbarColor"
      :footerType="footerType"
      @updateFooter="updateFooter"
      :routerTransition="routerTransition"
      @updateRouterTransition="updateRouterTransition"
      v-if="!disableCustomizer"
      :hideScrollToTop="hideScrollToTop"
      @toggleHideScrollToTop="toggleHideScrollToTop"
    />

    <vx-sidebar
      :sidebarItems="sidebarItems"
      :logo="require('@/assets/images/logo/logo.png')"
      :admin="admin"
      title="LAFEI"
      parent=".layout--main"
    />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay"></div>
      <div class="content-wrapper">

        <the-navbar
          :navbarColor="navbarColor"
          :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]"
          :admin="admin"
          @startBeginnerTour="startBeginnerTour"
          ref="navBar"
        />

        <div class="router-view">
          <div class="router-content" :class="{'mt-0': navbarType == 'hidden'}">
            <transition :name="routerTransition">
              <div class="router-header flex flex-wrap items-center mb-6" v-if="$route.meta.breadcrumb || $route.meta.pageTitle">
                <div class="content-area__heading" :class="{'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" />

              </div>
            </transition>
            <div class="content-area__content">
              <back-to-top bottom="5%" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg" />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @callRecharge="callRecharge"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer></the-footer>
    </div>

    <audio id="rechargeRemind">
      <source src="../../assets/media/recharge.mp3" type="audio/mp3">
    </audio>
    <audio id="cashRemind">
      <source src="../../assets/media/cash.mp3" type="audio/mp3">
    </audio>
  </div>
</template>

<script>

import VxSidebar from '@/layouts/components/vx-sidebar/VxSidebar.vue';
import TheCustomizer from "../components/customizer/TheCustomizer.vue";
import TheNavbar from '../components/TheNavbar.vue';
import TheFooter from '../components/TheFooter.vue';
import themeConfig from '@/../themeConfig.js';
import sidebarItems from "@/layouts/components/vx-sidebar/sidebarItems.js";
import BackToTop from 'vue-backtotop'
const VxTour = () => import('@/components/VxTour.vue')

export default {
  data() {
    return {
      admin: {},
      navbarType: themeConfig.navbarType || 'floating',
      navbarColor: themeConfig.navbarColor || '#fff',
      footerType: themeConfig.footerType || 'static',
      routerTransition: themeConfig.routerTransition || 'none',
      isNavbarDark: false,
      routeTitle: this.$route.meta.pageTitle,
      sidebarItems: sidebarItems,
      disableCustomizer: themeConfig.disableCustomizer,
      windowWidth: window.innerWidth,
      hideScrollToTop: themeConfig.hideScrollToTop,
      disableThemeTour: themeConfig.disableThemeTour,
      steps: [
        {
          target: '.logo-text',
          content: '欢迎使用天元娱乐系统，您可以点击下一步来熟悉后台，或者可以直接点击跳过.'
        },
        {
          target: '#btnSidebarToggler',
          content: '点击这里可以隐藏左侧边栏.'
        },
        {
          target: '.nav-change-theme-btn',
          content: '您可以点击这里自由切换绚丽的主题.'
        },
        {
          target: '.nav-recharge-btn',
          content: '点击这里可以快速给会员充值.'
        },
        {
          target: '.customizer-btn',
          content: '点击这里进行专业主题定制.',
          params: {
              placement: 'left'
          }
        }
      ]
    }
  },
  watch: {
    '$route'() {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark(val) {
      if(this.navbarColor == "#fff" && val) {
        this.updateNavbarColor("#10163a")
      }else {
        this.updateNavbarColor("#fff")
      }
    }
  },
  computed: {
    isAppPage() {
      if(this.$route.path.includes('/apps/')) return true
      else return false
    },
    isThemeDark() {
      return this.$store.state.theme == 'dark'
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay
    },
    contentAreaClass() {
      if(this.sidebarWidth == "default") return "content-area-default"
      else if(this.sidebarWidth == "reduced") return "content-area-reduced"
      else if(this.sidebarWidth) return "content-area-full"
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType == 'hidden',
        'navbar-sticky': this.navbarType == 'sticky',
        'navbar-static': this.navbarType == 'static',
        'navbar-floating': this.navbarType == 'floating'
      }
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static'
      }
    }
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbar(val) {
      if(val == 'static') this.updateNavbarColor("#fff")
      this.navbarType = val
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val == "#fff") this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter(val) {
      this.footerType = val
    },
    updateRouterTransition(val) {
      this.routerTransition = val
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth
      this.setSidebarWidth()
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false)
        this.$store.dispatch('updateSidebarWidth', 'no-sidebar')
        this.disableThemeTour = true
      }
      else if(this.windowWidth < 1200) {
          this.$store.dispatch('updateSidebarWidth', 'reduced')
      }
      else {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true)
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val
    },
    callRecharge(e) {
      this.$refs.navBar.showRecharge(e)
    },
    startBeginnerTour() {
      this.$refs.vxBeginnerTour.tourStart()
    },
    remind() {
      this.$utils.post('notification-remind', { authKey: localStorage.getItem('authKey') }, null, true).then(res => {
        const cashAudio = document.getElementById('cashRemind')
        const rechargeAudio = document.getElementById('rechargeRemind')
        if (res.cash == 1) {
          cashAudio.play()
          this.$vs.notify({
            title: '提醒',
            text: '您有新的提现申请，请处理',
            color:'danger',
            click: () => {
              this.$router.push({ name: 'recordCash' })
            }
          })
        } else {
          cashAudio.pause()
        }
        if (res.recharge == 1) {
          rechargeAudio.play()
          this.$vs.notify({
            title: '提醒',
            text: '您有新的充值申请，请验收',
            color:'success',
            click: () => {
              this.$router.push({ name: 'recordRecharge' })
            }
          })
        } else {
          rechargeAudio.pause()
        }
      })
    }
  },
  components: {
    VxSidebar,
    TheNavbar,
    TheFooter,
    TheCustomizer,
    BackToTop,
    VxTour
  },
  beforeCreate() {
    // 获取管理员信息
    this.$utils.post('admin-check', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.admin = res
    })

    // 检测更新
    this.$utils.post('other-checkUpdate', { authKey: localStorage.getItem('authKey') }).then(res => {
      if (res) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: '提示',
          text: '检测到新版本[V' + res + ']，是否前往更新?',
          acceptText: '去更新',
          cancelText: '暂不更新',
          accept: () => {
            this.$router.push({ name: 'otherUpdate' })
          }
        })
      }
    })
  },
  created() {
    this.setSidebarWidth()
    if(this.navbarColor == "#fff" && this.isThemeDark) {
      this.updateNavbarColor("#10163a")
    }else {
      this.updateNavbarColor(this.navbarColor)
    }

    // 充值提现提醒
    this.remind()
    setInterval(() => {
      this.remind()
    }, 3000)
  }
}
</script>
